import "./Category.scss"
import { QuestionAnswerDto } from "../../model/qualityCheckDtos"
import Answer from "./Answer"

interface CategoryProps {
    category: string
    answers: QuestionAnswerDto[]
}

export default function Category(props: CategoryProps) {
    return (
        <div className="category border-radius-small p-1 background-glass mt-1">
            <span className="question-category">
                {props.category}
            </span>
            {props.answers.map((item, index) => (
                <Answer key={`answer-${index}`} answer={item} />
            ))}
        </div>
    )
}
